var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyProfilingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 9.25H12L10.1667 13.8333L8.33333 4.66667L6.5 9.25H4.66667M2.83333 1H15.6667C16.6792 1 17.5 1.82081 17.5 2.83333V15.6667C17.5 16.6792 16.6792 17.5 15.6667 17.5H2.83333C1.82081 17.5 1 16.6792 1 15.6667V2.83333C1 1.82081 1.82081 1 2.83333 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyProfilingIcon);
export default __webpack_public_path__ + "static/media/StrategyProfilingIcon.397108eca3911f9921f533bc688655c2.svg";
export { ForwardRef as ReactComponent };